import { Injectable, Injector } from '@angular/core';
import { HttpDataService, ListHelperService } from 'core/services';
import { TableDatasource } from '@gamelearn/skeletor/models';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class GroupStudentsScoreService extends HttpDataService {
  constructor(
    protected injector: Injector,
    private listHelperService: ListHelperService,
    private translateService: TranslateService
  ) {
    super(injector, '/summaries');
  }

  /**
   * Fetch of the resource list
   * @param options
   * @param dataSource
   * @param group
   */
  fetch$({ page, limit, sort, search, filters, aggregates, populate }, dataSource: TableDatasource, group: any) {
    const url = `${this.baseUrl}/ranking/${group.type == 'itinerary' ? 'points' : 'scores'}/groups/${group.id}?lang=${
      this.translateService.currentLang
    }`;
    const { clientId, agentIds, distributorId, state, ...$filterValues } = filters;
    const $filter = this.listHelperService.buildFilterString($filterValues, dataSource);
    const paginationOptions = {
      page,
      limit,
      sort,
      search,
      aggregates,
      populate,
      clientId,
      agentIds,
      distributorId,
      state,
      $filter
    };
    return this.fetchRequest(url, paginationOptions);
  }
}
